import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from "./services/auth-guard.service";


const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', loadChildren: () => import('./home/home.module').then( m => m.HomePageModule)},

  {
    path: 'menu',
    loadChildren: () => import('./menu/menu.module').then( m => m.MenuPageModule),
  },

  {
    path: 'misreportes',
    loadChildren: () => import('./misreportes/misreportes.module').then( m => m.MisreportesPageModule),
    canActivate: [AuthGuardService]
  },
  
  {
    path: 'signup',
    loadChildren: () => import('./signup/signup.module').then( m => m.SignupPageModule)
  },
  {
    path: 'modal-dataset',
    loadChildren: () => import('./modal-dataset/modal-dataset.module').then( m => m.ModalDatasetPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'modal-upload',
    loadChildren: () => import('./modal-upload/modal-upload.module').then( m => m.ModalUploadPageModule)
  },
  {
    path: 'mis-permisos',
    loadChildren: () => import('./mis-permisos/mis-permisos.module').then( m => m.MisPermisosPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'modal-crear-trabajador',
    loadChildren: () => import('./modal-crear-trabajador/modal-crear-trabajador.module').then( m => m.ModalCrearTrabajadorPageModule)
  },
  {
    path: 'modal-buscar-trabajador',
    loadChildren: () => import('./modal-buscar-trabajador/modal-buscar-trabajador.module').then( m => m.ModalBuscarTrabajadorPageModule)
  },
  {
    path: 'modal-editar-trabajador',
    loadChildren: () => import('./modal-editar-trabajador/modal-editar-trabajador.module').then( m => m.ModalEditarTrabajadorPageModule)
  },
  {
    path: 'modal-actividades-trabajador',
    loadChildren: () => import('./modal-actividades-trabajador/modal-actividades-trabajador.module').then( m => m.ModalActividadesTrabajadorPageModule)
  },
  {
    path: 'paso1page',
    loadChildren: () => import('./paso1page/paso1page.module').then( m => m.Paso1pagePageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'paso2page',
    loadChildren: () => import('./paso2page/paso2page.module').then( m => m.Paso2pagePageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'paso3page',
    loadChildren: () => import('./paso3page/paso3page.module').then( m => m.Paso3pagePageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'paso3Apage',
    loadChildren: () => import('./paso-soportes/paso-soportes.module').then( m => m.PasoSoportesPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'paso4page',
    loadChildren: () => import('./paso4page/paso4page.module').then( m => m.Paso4pagePageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'paso5page',
    loadChildren: () => import('./paso5page/paso5page.module').then( m => m.Paso5pagePageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'paso6page',
    loadChildren: () => import('./paso6page/paso6page.module').then( m => m.Paso6pagePageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'modal-herramientas-ycontroles',
    loadChildren: () => import('./modal-herramientas-ycontroles/modal-herramientas-ycontroles.module').then( m => m.ModalHerramientasYControlesPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'paso7page',
    loadChildren: () => import('./paso7page/paso7page.module').then( m => m.Paso7pagePageModule),
    canActivate: [AuthGuardService]
  },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
